export default "__VITE_ASSET__C03a1cKD__"